import { render, staticRenderFns } from "./DrugDetail.vue?vue&type=template&id=2c1a6fbe&scoped=true&"
import script from "./DrugDetail.vue?vue&type=script&lang=js&"
export * from "./DrugDetail.vue?vue&type=script&lang=js&"
import style0 from "./DrugDetail.vue?vue&type=style&index=0&id=2c1a6fbe&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c1a6fbe",
  null
  
)

export default component.exports